<script setup>

import { RouterLink } from 'vue-router'
</script>

<template>
  <header>
    <div class="navbar-wrapper">
      <div class="navbar">
        <div class="logo"> <img src="@/assets/logo.jpeg" alt="logo"></div>
        <ul>
          <li><RouterLink to="/">{{$language._l('menu.link_main')}}</RouterLink></li>
          <li><RouterLink to="/sign-in">{{$language._l('menu.link_sign_in')}}</RouterLink></li>
          <li  v-if="$user.can('users.browse')" ><RouterLink to="/users">{{$language._l('menu.link_users')}}</RouterLink></li>
          <li><RouterLink to="/events">{{$language._l('menu.link_events')}}</RouterLink></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {

}

</script>